import React from "react";
import styles from "./Terms.module.css";
import TermsItem from "../../Components/CustomerServices/TermsItem";
import * as Gr from "react-icons/gr";
// import styles from './Terms.module.css';
import commonStyles from "../../Components/Shared/commonStyles.module.css";

const host = window.location.hostname; // e.g. "shop.example.com"
const origin = window.location.origin; // e.g. "https://shop.example.com"
const fqdn = `${window.location.protocol}//${window.location.host}`;

const Terms = () => (
  <div className={commonStyles.section}>
    <div className={commonStyles.container}>
      <div className={commonStyles.sectionHeaderContainer}>
        <h2 className={commonStyles.sectionHeader}>
          Terms, Policies & Privacy
        </h2>
        <p className={commonStyles.paragraph}>Last updated: August 2026</p>
        <hr />

        <div className={styles.TermsItem}>
          <ol>
            <li id="introduction">
              <div className={styles.TermsItemHeader}>Introduction</div>
              <p>
                This website, <i>{host}</i> (“the Website”), is owned and
                operated by:
                <ul>
                  <li>
                    Matchhampers Ltd. (Registered in England & Wales, Company
                    No. 13238757)
                  </li>
                  <li>
                    Matchhampers (Jersey) Ltd. (Registered in Jersey, Company
                    No. 156161)
                  </li>
                </ul>
              </p>
              <p>
                Registered address: 8 La Courte Piece, La Verte Rue, St Brelade,
                Jersey, JE3 8DF
              </p>
              <p>
                References to “Match Hampers”, “we”, “us”, or “our” refer to the
                above entities. References to “you” or “your” mean any person
                using our Website or purchasing from us.
              </p>
              <p>
                By using this Website or placing an order, you agree to be bound
                by these Terms, Policies, and Privacy provisions.
              </p>
            </li>
            <li id="use-of-the-website">
              <div className={styles.TermsItemHeader}>Use of the Website</div>
              <p>
                You may use the Website for personal, non-commercial purposes
                only. By accessing or using the Website, you agree that you will
                not:
                <ul>
                  <li>Copy, modify, or reproduce content without permission</li>
                  <li>
                    Use Match Hampers trademarks, logos, or imagery without
                    written consent
                  </li>
                  <li>Interfere with or disrupt the Website or its networks</li>
                  <li>
                    Use the Website for fraudulent, unlawful, or misleading
                    purposes
                  </li>
                </ul>
              </p>
              <p>
                While we aim to provide accurate product information, we cannot
                guarantee perfect colour or description accuracy due to screen
                variations.
              </p>
            </li>
            <li id="formation-of-contract">
              <div className={styles.TermsItemHeader}>
                Formation of Contract
              </div>
              <p>
              <ul>
                <li>
                  Orders submitted via email or WhatsApp are treated as offers
                  to purchase.
                </li>
                <li>
                  An order becomes legally binding only when we confirm
                  acceptance.
                </li>
                <li>
                  We reserve the right to refuse or cancel orders if payment is
                  not received, products are unavailable, or personalisation
                  requests are unsuitable.
                </li>
              </ul>
              </p>
            </li>
            <li id="ordering-process">
              <div className={styles.TermsItemHeader}>Ordering Process</div>
                <p>
              <ul>
                <li>Browse products and hampers online.</li>
                <li>
                  Contact us via email or WhatsApp with:
                  <ul>
                    <li>Selected products and sizes/colours</li>
                    <li>Personalisation details</li>
                    <li>Gift tag message</li>
                  </ul>
                </li>
                <li>
                  We confirm your order, provide payment details, and agree a
                  delivery date.
                </li>
                <li>
                  Payment must be received before your order is processed.
                </li>
                <li>
                  Tip: Order early for busy seasons such as Mother’s Day,
                  Father’s Day, and Christmas.
                </li>
              </ul>
                </p>
            </li>
             <li id="Liquor-licensing">
              <div className={styles.TermsItemHeader}>Liquor Licensing</div>
                <p>
              <ul>
                <li>You can request alcohol to be added to a hamper, because we have a sixth category liquor license in Jersey. </li>
                <li>Alcohol cannot be sold separately from a hamper.</li>
                <li>Alcohol cannot be sold to anyone under the age of 18.</li>                
                <li>Delivery of alcohol is subject to the same age restrictions.</li>
                <li>Recipients must not be under the influence of alcohol.</li>
              </ul>
                </p>
            </li>
            <li id="pricing-and-payment">
              <div className={styles.TermsItemHeader}>Pricing & Payment</div>
              <p>
              <ul>
                <li>
                  Prices are in GBP (£), including relevant Jersey/UK taxes,
                  unless stated.
                </li>
                <li>
                  Prices may change without notice, but confirmed orders are
                  honoured at the quoted price.
                </li>
                <li>
                  Accepted payment methods are shared upon order confirmation.
                </li>
                <li>Orders are not processed until payment clears.</li>
              </ul>
              </p>
            </li>
            <li id="delivery-policy">
              <div className={styles.TermsItemHeader}>Delivery Policy</div>
              <p>
              <ul>
                <li>Free local delivery across Jersey on all orders.</li>
                <li>Delivery is arranged directly with you.</li>
                <li>
                  Overseas delivery may be possible on request; costs and
                  arrangements agreed prior to confirmation.
                </li>
                <li>
                  While we aim to deliver on time, delays may occur due to
                  circumstances outside our control.
                </li>
              </ul>
              </p>
            </li>
            <li id="personalisation-guidelines">
              <div className={styles.TermsItemHeader}>
                Personalisation Guidelines
              </div>
              <p>
              <ul>
                <li>
                  Check spelling, punctuation, capitalisation, and colours
                  before confirming your order.
                </li>
                <li>Once payment is confirmed, changes cannot be made.</li>
                <li>
                  Some products cannot be personalised due to material
                  constraints.
                </li>
                <li>
                  Personalisation may include names, initials, quotes, or simple
                  designs.
                </li>
                <li>
                  Requests involving copyrighted or trademarked images cannot be
                  accepted.
                </li>
              </ul>
              </p>
            </li>
            <li id="gift-wrap">
              <div className={styles.TermsItemHeader}>Gift Wrap </div>
              <p>
              <ul>
                <li>
                  Every hamper is beautifully wrapped in our signature
                  tissue and ribbon, finished with a gift tag.
                </li>
                <li>You may provide a personalised gift tag message.</li>
                <li>
                  Please check spelling and punctuation; we are not responsible
                  for errors.
                </li>
                <li>
                  We reserve the right to decline offensive or inappropriate
                  messages.
                </li>
              </ul>
              </p>
            </li>
            <li id="returns-refunds-cancellations">
              <div className={styles.TermsItemHeader}>
                Returns, Refunds & Cancellations
              </div>
              <p>
              <ul>
                <li>
                  Most products are personalised, so refunds and cancellations
                  are generally not available.
                </li>
                <li>
                  Faulty or damaged items: contact us within 28 days with photos
                  and order details.
                </li>
                <li>
                  Approved refunds or replacements are processed within 14 days.
                </li>
              </ul>
              </p>
            </li>
            <li id="privacy-and-data-protection">
              <div className={styles.TermsItemHeader}>
                Privacy & Data Protection
              </div>
              <p>Data Controller</p>
              <p>
              <ul>
                <li>
                  Match Hampers Ltd. and Match Hampers (Jersey) Ltd. act as data
                  controllers.
                </li>
              </ul>
              </p>
              <p>Data Collected</p>
              <p>
              <ul>
                <li>Name, email, phone number, delivery address</li>
                <li>Personalisation details (text, colours, designs)</li>
                <li>Order history, messages, and payment confirmation</li>
                <li>Optional marketing consent</li>
              </ul>
              </p>
              <p>Purpose of Processing</p>
              <p>
              <ul>
                <li>
                  To process and deliver orders, including personalisation
                </li>
                <li>To provide customer support</li>
                <li>To comply with legal obligations</li>
                <li>Optional: marketing communications (with consent)</li>
              </ul>
              </p>
              <p>Legal Basis</p>
              <p>
              <ul>
                <li>Contract: fulfilling orders and services</li>
                <li>Legitimate interest: operating the business</li>
                <li>Consent: for marketing communications</li>
              </ul>
              </p>
              <p>Data Sharing</p>
              <p>
              <ul>
                <li>Shared only with:</li>
                <ul>
                  <li>Payment processors</li>
                  <li>Delivery providers</li>
                  <li>IT service providers</li>
                </ul>
                <li>No data is sold or rented.</li>
              </ul>
              </p>
              <p>International Transfers</p>
              <p>
              <ul>
                <li>
                  Data may be transferred outside Jersey/UK for processing or
                  delivery with safeguards in place.
                </li>
              </ul>
              </p>
              <p>Data Retention</p>
              <p>
              <ul>
                <li>
                  Retained only as long as necessary to fulfil orders or legal
                  requirements.
                </li>
                <li>Marketing data retained until consent is withdrawn.</li>
              </ul>
              </p>
              <p>Your Rights</p>
              <p>
              <ul>
                <li>
                  Access, correction, deletion, restriction, objection, data
                  portability
                </li>
                <li>Withdraw marketing consent</li>
                <li>
                  Lodge a complaint with the Jersey Data Protection Commissioner
                  or ICO (UK)
                </li>
              </ul>
              </p>
              <p>Security</p>
              <p>
              <ul>
                <li>
                  Technical and organisational measures to protect personal data
                </li>
                <li>
                  Email and WhatsApp communications are secure but sensitive
                  info (e.g., payment card numbers) should not be sent outside
                  approved channels
                </li>
              </ul>
              </p>
              <p>Children</p>
              <p>
              <ul>
                <li>Website and services are not for individuals under 18.</li>
              </ul>
              </p>
            </li>
            <li id="intellectual-property">
              <div className={styles.TermsItemHeader}>
                Intellectual Property
              </div>
              <p>
              <ul>
                <li>
                  All website content, including images, text, logos, and
                  designs, belongs to Match Hampers.
                </li>
                <li>
                  No content may be reproduced without written permission.
                </li>
              </ul>
              </p>
            </li>
            <li id="liability-and-disclaimer">
              <div className={styles.TermsItemHeader}>
                Liability & Disclaimer
              </div>
              <p>
              <ul>
                <li>
                  We are not liable for indirect, incidental, or consequential
                  losses.
                </li>
                <li>
                  We are not responsible for delays caused by circumstances
                  beyond our control (Force Majeure).
                </li>
              </ul>
              </p>
            </li>
            <li id="governing-law-and-jurisdiction">
              <div className={styles.TermsItemHeader}>
                Governing Law & Jurisdiction
              </div>
              <p>
              <ul>
                <li>Jersey orders → governed by Jersey law</li>
                <li>
                  UK orders → governed by England & Wales law and Jersey laws
                </li>
                <li>Exclusive jurisdiction of relevant courts applies.</li>
              </ul>
              </p>
            </li>
            <li id="updates-to-terms-policies-and-privacy">
              <div className={styles.TermsItemHeader}>
                Updates to Terms, Policies & Privacy
              </div>
              <p>
              <ul>
                <li>We may update this document periodically.</li>
                <li>Last updated date is always displayed.</li>
                <li>
                  Continued use of the website constitutes acceptance of the
                  latest version.
                </li>
              </ul>
              </p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
);

export default Terms;
